import { FC } from "react";
import { Card } from "react-bootstrap";
import { TeamMember } from "@models/teamMember.model";

interface TeamItemProps {
    teamMember: TeamMember,
    onEdit: (teamMember: TeamMember) => void,
    onDelete: (teamMember: TeamMember) => void,
}

const TeamItem: FC<TeamItemProps> = ({ teamMember, onEdit, onDelete }) => {
    const person = teamMember.employee.person;
    // Assigned roles first: an implied one is a consequence of an Organization
    // role and is not what the person was put on this engagement to do.
    const roles = [...teamMember.roles].sort(
        (a, b) => Number(a.is_implied) - Number(b.is_implied),
    );

    return (
        <Card className="custom-card text-center border shadow-none">
            <Card.Header className="card-header border-bottom-0 pb-0 d-flex justify-content-between">
                <span className="shadow-lg fs-17" onClick={() => onDelete(teamMember)} role="button">
                    <i className="bi bi-trash text-gray"></i>
                </span>
                <span className="shadow-lg fs-17" onClick={() => onEdit(teamMember)} role="button">
                    <i className="bi bi-pencil text-gray"></i>
                </span>
            </Card.Header>
            <Card.Body className="card-body pt-1">
                {person.profile_picture.storage_uri == null ? (
                    <span className="avatar avatar-xl m-2 avatar-rounded bg-primary text-capitalize">
                        {person.first_name.substring(0, 1)}
                        {person.last_name.substring(0, 1)}
                    </span>
                ) : (
                    <span className="avatar avatar-xl avatar-rounded me-2 mb-2 text-capitalize">
                        <img src={person.profile_picture.storage_uri} alt="img" />
                    </span>
                )}
                <div className="fw-semibold fs-15 d-flex justify-content-center">
                    <span>{person.first_name} {person.last_name}</span>
                </div>

                {roles.length === 0 ? (
                    <p className="mb-2 text-muted fs-12">No role</p>
                ) : (
                    <div className="team-roles">
                        {roles.map((role) => (
                            <span
                                key={role.value}
                                className={`team-role${role.is_implied ? " team-role--implied" : ""}`}
                                title={role.is_implied ? "From an Organization role" : undefined}
                            >
                                {role.label}
                            </span>
                        ))}
                    </div>
                )}

                <p className="my-0 text-muted fs-11">
                    {person.phone ? `(${person.phone.slice(0, 3)}) ${person.phone.slice(3, 6)}-${person.phone.slice(6, 10)}` : 'No phone number'}
                </p>
                <p className="text-muted fs-11">
                    {person.email}
                </p>
            </Card.Body>
        </Card>
    )
}

export default TeamItem;
